<h1 mat-dialog-title><span *ngIf="!deploymentEntity.id">Add</span><span *ngIf="deploymentEntity.id">Edit</span> Group</h1>
<div mat-dialog-content>
    <form [formGroup]="form" class="group-form">
        <mat-tab-group class="vertical-tabs">
            <mat-tab label="Group Name">
                <div fxLayout="column" class="form-field-outer">
                    <mat-form-field class="w-100">
                        <mat-placeholder>
                            <mat-icon>groups</mat-icon>
                            group name
                        </mat-placeholder>
                        <input matInput formControlName="name" required [matAutocomplete]="auto">
                        <mat-error *ngIf="form.controls['name'].errors?.required">Group Name is required</mat-error>
                        <mat-error *ngIf="form.controls['name'].hasError('minlength')">Group Name  isn't long enough,
                            minimum of 5 characters
                        </mat-error>
                    </mat-form-field>
                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngFor="let group of filteredGroups | async" [value]="group.name">{{group.name}}</mat-option>
                    </mat-autocomplete>
                </div>
            </mat-tab>

        </mat-tab-group>
    </form>
</div>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-raised-button color="warn" (click)="close()">Cancel</button>
    <button mat-raised-button color="primary"
            (click)="saveGroup()"
            [mat-dialog-close]="form.value" [disabled]="!form.valid"><span
            *ngIf="!deploymentEntity.id">Create</span><span *ngIf="deploymentEntity.id">Save</span></button>

</div>
